module.exports = __webpack_public_path__ + "img/909473_555D4B_C2CCA2_645B3C-256px.b9552469.png";